import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const organizationApi = createApi({
    reducerPath: "base/organization",
    baseQuery: axiosBaseQuery,
    tagTypes: ["organizationlist"],
    endpoints: (builder) =>({
        orgFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            query: (query = '') => ({
              url: "/base/organization" + query,
              method: "GET",
            }),
            transformResponse: (response: any) => {
                console.log('end bn', response);
                return {
                  data: response.data, // The array of data
                  pagination: response.pagination, // Pagination info
                };
              },
            providesTags: ["organizationlist"],
        }),   
        orgCreate: builder.mutation({
            invalidatesTags: ['organizationlist'],
            query: (data)=>({url: "/base/organization", method: "POST", data})
        }),
        orgUpdate: builder.mutation({
            invalidatesTags: ['organizationlist'],
            query: (data)=>({url: "/base/organization/"+data.id, method: "PUT", data})
        }),
        orgDelete: builder.mutation({
            invalidatesTags: ['organizationlist'],
            query: (id)=>({url: "/base/organization/"+id, method: "DELETE"})
        }),
    })
})

export const { useOrgFindAllQuery, useOrgCreateMutation, useOrgUpdateMutation, useOrgDeleteMutation } = organizationApi;
export {organizationApi};
